import React from 'react';
import WeightUnitManageScreens from './screens/WeightUnitManageScreens';

export default function WeightUnitManage() {
  return <WeightUnitManageScreens />;
}
